module.exports = __webpack_public_path__ + "Frame71.svg?7927b91aba3f3564bcfa7759b641fc2d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Frame71.svg
// module id = 90
// module chunks = 0